import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import $ from "jquery";
import Swal from "sweetalert2";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
// Types only: adds `$(...).DataTable()` to the JQuery type
import type {} from "datatables.net";

import { url } from "../../../store/initialStatus";
import { Translate } from "../../../helpers/Translate";
import "./Resturant.css";

/**
 * Cafeteria allowed items: for every item and every student the guardian
 * chooses "Allow" / "Don't Allow". Items default to allowed. The header
 * buttons of each student column set all items at once.
 */
const CafeteriaMenu = () => {
  const Navigate = useNavigate();
  const [Items, SetItems] = useState<any>([]);
  const [Students, SetStudents] = useState<any>([]);
  // One entry per (student, item): { itemcode, student_id, allowed }
  const [Preference, SetPreference] = useState<any>([]);
  const t = new Translate();

  // Load items, students and saved preferences; fill missing pairs as allowed
  useEffect(() => {
    axios.get(`${url}alloweditems/getutils.php`).then((res: any) => {
      SetStudents(res.data.data.students);
      SetItems(res.data.data.items);
      let R = res.data.data.relations;
      res.data.data.students.forEach((s: any) => {
        res.data.data.items.forEach((item: any) => {
          let i = R.findIndex(
            (p: any) => p.student_id === s.id && p.itemcode === item.ItemCode
          );
          if (i === -1) {
            R.push({
              itemcode: item.ItemCode,
              student_id: s.id,
              allowed: true,
            });
          }
        });
      });
      SetPreference(R);
    });
  }, []);

  // Enhance the table only after React has rendered the loaded columns/rows;
  // initialising earlier makes DataTables cache an empty table and wipe them.
  useEffect(() => {
    if (!Items.length) return;
    const table = $("#datatable").DataTable({});
    return () => {
      table.destroy();
    };
  }, [Items, Students]);

  /** Sets one item for one student. */
  const ChangePreference = (std_id: string, itemCode: string, val: boolean) => {
    SetPreference((prev: any) => {
      let newArray = [...prev];
      let i = newArray.findIndex(
        (p: any) => p.student_id === std_id && p.itemcode === itemCode
      );
      if (i !== -1) {
        newArray[i].allowed = val;
        return newArray;
      } else {
        newArray.push({ itemcode: itemCode, student_id: std_id, allowed: val });
        return newArray;
      }
    });
  };

  /** Sets every item for one student. */
  const defaultPref = (std_id: string, val: boolean) => {
    SetPreference((prev: any) => {
      let newArray = [...prev];
      Items.forEach((item: any) => {
        let i = newArray.findIndex(
          (p: any) => p.student_id === std_id && p.itemcode === item.ItemCode
        );
        if (i !== -1) {
          newArray[i].allowed = val;
        } else {
          newArray.push({
            itemcode: item.ItemCode,
            student_id: std_id,
            allowed: val,
          });
        }
      });
      return newArray;
    });
  };

  const Submit = () => {
    Swal.showLoading();
    axios
      .post(`${url}alloweditems/saveitems.php`, Preference)
      .then((res: any) => {
        if (res.data.data === "success") {
          Swal.fire("Saved Successfully", "", "success").then(() => {
            Navigate("dashboard/home");
          });
        } else {
          Swal.close();
        }
      })
      .catch(() => {
        Swal.close();
      });
  };

  return (
    <div className="content">
      <div className="pp-cafe-card pp-cafe-card--padded">
        <div className="table-responsive">
          <table id="datatable" className="table table-striped table-hover">
            <thead>
              <tr>
                <th>{t.translate("Item name")} (EN)</th>
                <th>{t.translate("Item name")} (AR)</th>
                <th>
                  {t.translate("Price")} ({t.translate("LE")})
                </th>
                {/* One column per student; header buttons apply to all items */}
                {Students.map((s: any) => {
                  return (
                    <th key={s.id}>
                      <div className="pp-allow-student">
                        <span>{`${s.id}:${s.fullname}`}</span>
                        <div className="pp-allow-toggle">
                          <input
                            type="radio"
                            onChange={() => {
                              defaultPref(s.id, true);
                            }}
                            className="btn-check"
                            name={s.id + "-Gstatus"}
                            id={s.id + "-classroom"}
                            autoComplete="off"
                          />
                          <label
                            className="btn btn-outline-success"
                            htmlFor={s.id + "-classroom"}
                          >
                            <i className="fas fa-check" aria-hidden="true"></i>{" "}
                            {t.translate("Allow")}
                          </label>

                          <input
                            type="radio"
                            onChange={() => {
                              defaultPref(s.id, false);
                            }}
                            className="btn-check"
                            name={s.id + "-Gstatus"}
                            id={s.id + "-absent"}
                            autoComplete="off"
                          />
                          <label
                            className="btn btn-outline-danger"
                            htmlFor={s.id + "-absent"}
                          >
                            <i className="fas fa-ban" aria-hidden="true"></i>{" "}
                            {t.translate("Don't Allow")}
                          </label>
                        </div>
                      </div>
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {Items.map((item: any) => {
                return (
                  <tr key={item.ItemCode}>
                    <td> {item.ItemEname} </td>
                    <td> {item.ItemAname} </td>
                    <td className="pp-cafe-price">{item.SellingPrice}</td>
                    {Students.map((s: any) => {
                      // Missing preference means allowed
                      let allowed = true;
                      let temp = Preference.find(
                        (p: any) =>
                          p.student_id === s.id && p.itemcode === item.ItemCode
                      );
                      if (temp) {
                        if (temp.allowed == false) {
                          allowed = false;
                        }
                      }
                      return (
                        <td key={`${item.ItemCode}-${s.id}`}>
                          <div className="pp-allow-toggle">
                            <input
                              type="radio"
                              onChange={() => {
                                ChangePreference(s.id, item.ItemCode, true);
                              }}
                              className="btn-check"
                              name={`${item.ItemCode}-${s.id}`}
                              id={`${item.ItemCode}-${s.id}-Allowed`}
                              autoComplete="off"
                              checked={allowed}
                            />
                            <label
                              className="btn btn-outline-success"
                              htmlFor={`${item.ItemCode}-${s.id}-Allowed`}
                            >
                              {t.translate("Allow")}
                            </label>

                            <input
                              type="radio"
                              onChange={() => {
                                ChangePreference(s.id, item.ItemCode, false);
                              }}
                              className="btn-check"
                              name={`${item.ItemCode}-${s.id}`}
                              id={`${item.ItemCode}-${s.id}-no`}
                              autoComplete="off"
                              checked={!allowed}
                            />
                            <label
                              className="btn btn-outline-danger"
                              htmlFor={`${item.ItemCode}-${s.id}-no`}
                            >
                              {t.translate("Don't Allow")}
                            </label>
                          </div>
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      <div className="pp-cafe-save">
        <button
          type="button"
          className="btn btn-warning btn-lg"
          onClick={() => {
            Submit();
          }}
        >
          <i className="fas fa-save" aria-hidden="true"></i>
          {t.translate("Save !!!")}
        </button>
      </div>
    </div>
  );
};

export default CafeteriaMenu;
